import { render, staticRenderFns } from "./CommonComponent.vue?vue&type=template&id=37fbfc02&"
import script from "./CommonComponent.vue?vue&type=script&lang=js&"
export * from "./CommonComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommonComponent.vue?vue&type=style&index=0&id=37fbfc02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports